import React from 'react';

import { IconProps, StyledPath, StyledStrokedGroup, StyledSvg } from '../iconCommons';

export const IconShield = ({ color = 'currentColor', size = 'micro', ...props }: IconProps) => (
    <StyledSvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 20" size={size} {...props}>
        <StyledStrokedGroup color={color} strokeLinecap="round" strokeLinejoin="round">
            <StyledPath
                d="M16.3075 13.5574L4.16664 1.23572C3.28652 1.46152 2.42729 1.76206 1.5983 2.13405C1.38114 2.23335 1.19732 2.39333 1.06898 2.5947C0.940645 2.79608 0.873269 3.03026 0.87497 3.26905V4.30155L13.695 17.1174C14.8218 16.1417 15.7147 14.925 16.3075 13.5574Z"
                color="none"
            />
            <StyledPath
                d="M0.874967 3.26909V9.61409C0.874984 11.6196 1.48273 13.5781 2.6181 15.2313C3.75347 16.8845 5.36315 18.1549 7.23497 18.8749L8.10247 19.2083C8.68017 19.4305 9.31976 19.4305 9.89747 19.2083L10.765 18.8749C12.6368 18.1549 14.2465 16.8845 15.3818 15.2313C16.5172 13.5781 17.1249 11.6196 17.125 9.61409V3.26909C17.1266 3.03033 17.0591 2.79618 16.9308 2.59483C16.8025 2.39347 16.6187 2.23348 16.4016 2.13409C14.0682 1.11558 11.5459 0.601307 8.99997 0.624924C6.45401 0.601307 3.93177 1.11558 1.5983 2.13409C1.3812 2.23348 1.19743 2.39347 1.06911 2.59483C0.940787 2.79618 0.87337 3.03033 0.874967 3.26909V3.26909Z"
                color="none"
            />
        </StyledStrokedGroup>
    </StyledSvg>
);
